import ReactApexChart from 'react-apexcharts';
import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import { ChartColors } from '../constants';

const BidsOverTime = ({
    bids,
    t,
}) => {
    const chartOptions = {
        colors: [ChartColors.info],
        chart: {
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '45%',
                borderRadius: 3,
            },
        },
        dataLabels: {
            enabled: false,
        },
        grid: {
            borderColor: '#F1F1F1',
        },
        legend: {
            show: false,
        },
        xaxis: {
            categories: bids.categories.map((category) => t(category)),
            axisTicks: {
                show: false,
            },
        },
        yaxis: {
            labels: {
                formatter: (value) => value.toFixed(0),
            },
        },
        tooltip: {
            theme: 'light',
        },
    };

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <CardTitle tag="h6" className="mb-1">
                    {t('Bids Over Time')}
                </CardTitle>

                <p className="text-muted font-size-12 mb-3">
                    {t('Number of bids received per month.')}
                </p>

                <ReactApexChart
                    options={chartOptions}
                    series={[{
                        name: t('Bids'),
                        data: bids.amounts,
                    }]}
                    type="bar"
                    height="250"
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    BidsOverTime
);
